// Shared styles for all Inventory components — matches Menuron design language

export const card = {
  background: 'white',
  borderRadius: '16px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
  border: '1px solid rgba(0,0,0,0.06)',
};

export const btn = (variant = 'primary', disabled = false) => {
  const base = {
    border: 'none', borderRadius: '10px',
    padding: '10px 20px', fontSize: '0.92rem', fontWeight: '700',
    cursor: disabled ? 'not-allowed' : 'pointer', transition: 'all 0.2s',
  };
  if (disabled) return { ...base, background: '#e5e7eb', color: '#9ca3af' };
  if (variant === 'primary')  return { ...base, background: 'linear-gradient(135deg, #FF4444, #FF6B00)', color: 'white', boxShadow: '0 3px 10px rgba(255,68,68,0.25)' };
  if (variant === 'green')    return { ...base, background: '#16a34a', color: 'white' };
  if (variant === 'orange')   return { ...base, background: '#FF6B00', color: 'white' };
  if (variant === 'outline')  return { ...base, background: 'transparent', color: '#666', border: '2px solid #e5e7eb' };
  if (variant === 'danger')   return { ...base, background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' };
  if (variant === 'sm')       return { ...base, padding: '6px 14px', fontSize: '0.82rem' };
  return base;
};

export const inputStyle = (hasError = false) => ({
  width: '100%', padding: '10px 12px',
  border: `2px solid ${hasError ? '#dc2626' : '#e5e7eb'}`,
  borderRadius: '10px', fontSize: '0.95rem', outline: 'none',
  boxSizing: 'border-box', fontFamily: 'inherit',
});

export const selectStyle = (hasError = false) => ({
  ...inputStyle(hasError),
  background: 'white', cursor: 'pointer',
});

export const label = {
  display: 'block', marginBottom: '6px',
  fontSize: '0.85rem', fontWeight: '600', color: '#444',
};

export const fieldGroup = { marginBottom: '16px' };

export const statusBadge = (type) => {
  const styles = {
    low_stock:   { background: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa' },
    out_of_stock:{ background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' },
    ok:          { background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' },
    draft:       { background: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' },
    sent:        { background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe' },
    part_received:{ background: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa' },
    received:    { background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' },
    cancelled:   { background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' },
    in_progress: { background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe' },
    completed:   { background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' },
  };
  const s = styles[type] || styles.draft;
  return {
    ...s, display: 'inline-block',
    padding: '3px 10px', borderRadius: '20px',
    fontSize: '0.75rem', fontWeight: '700',
  };
};

export const pageWrap = {
  minHeight: 'calc(100vh - 90px)',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf0 100%)',
  padding: '24px 20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const modal = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000, padding: '20px',
};

export const modalBox = {
  background: 'white', borderRadius: '20px',
  width: '100%', maxWidth: '560px',
  maxHeight: '90vh', overflowY: 'auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  padding: '28px',
};

export const sectionTitle = {
  fontSize: '1.3rem', fontWeight: '800', color: '#111', margin: '0 0 6px 0',
};

export const errorBox = {
  background: '#fee2e2', border: '1px solid #fca5a5',
  borderRadius: '10px', padding: '12px 16px',
  color: '#dc2626', fontSize: '0.88rem', marginBottom: '16px',
};

export const emptyState = {
  textAlign: 'center', padding: '60px 20px',
  color: '#9ca3af', fontSize: '0.95rem',
};

export const fmtQty  = (n, decimals = 3) => (parseFloat(n) || 0).toFixed(decimals).replace(/\.?0+$/, '') || '0';
export const fmtCost = (n) => `₹${(parseFloat(n) || 0).toFixed(2)}`;
export const fmtDate = (ts) => {
  if (!ts) return '—';
  return new Date(ts).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
export const fmtDateTime = (ts) => {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true });
};

export const friendlyErr = (err) => {
  if (!err) return 'Something went wrong.';
  const msg = String(err.message || err).toLowerCase();
  if (msg.includes('fetch') || msg.includes('network')) return 'Network error — check your connection.';
  if (msg.includes('duplicate') || msg.includes('unique')) return 'A record with this name already exists.';
  if (msg.includes('foreign key')) return 'This item is linked to other records and cannot be removed.';
  if (msg.includes('jwt') || msg.includes('auth')) return 'Session expired — please refresh.';
  return 'Something went wrong. Please try again.';
};
